// Shared Vuetify-compatible validation rules for password and email fields.
// Consumed by BusinessSignUpComponent and the M3 RegistrationStepper.
// Each rule returns `true` for valid input or a human-readable error string.

export const required = (v) => !!v || "This field is required";

export const email = (v) =>
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/.test(v) ||
  "E-mail must be valid";

export const password = (v) => {
  if (!v) return "This field is required";
  if (v.length < 8) return "Must be at least 8 characters";
  if (!/[A-Z]/.test(v)) return "Must include at least one uppercase letter";
  if (!/[a-z]/.test(v)) return "Must include at least one lowercase letter";
  if (!/[0-9]/.test(v)) return "Must include at least one number";
  return true;
};

export const businessIdFormat = (v) => {
  if (!v) return "This field is required";
  return /^[a-z0-9]+$/.test(v) || "Only lowercase letters and numbers allowed";
};

export const threshold = (v) =>
  (Number.isFinite(Number(v)) && Number(v) >= 6 && Number(v) <= 14) ||
  "Must be between 6 and 14";

// Whole number of 1 or more. Plans are billed once per location, so the
// count has to be something Stripe can use as a quantity.
export const locationCount = (v) =>
  (Number.isInteger(Number(v)) && Number(v) >= 1) ||
  "Enter a whole number of 1 or more";

export const fullName = (v) => {
  if (!v) return "This field is required";
  const letters = (String(v).match(/\p{L}/gu) || []).length;
  return letters >= 4 || "Must include at least 4 letters";
};

// Convenience bundle for components that want a single object.
export const passwordRules = {
  required,
  email,
  password,
  businessIdFormat,
  threshold,
  locationCount,
  fullName,
};

export default passwordRules;
